import { render, staticRenderFns } from "./mediaPublishMulCoverUpload.vue?vue&type=template&id=b54ca194&scoped=true&"
import script from "./mediaPublishMulCoverUpload.vue?vue&type=script&lang=js&"
export * from "./mediaPublishMulCoverUpload.vue?vue&type=script&lang=js&"
import style0 from "./mediaPublishMulCoverUpload.vue?vue&type=style&index=0&id=b54ca194&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54ca194",
  null
  
)

component.options.__file = "mediaPublishMulCoverUpload.vue"
export default component.exports